/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */
import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Subject, debounceTime, distinctUntilChanged, filter, startWith, switchMap, takeUntil } from 'rxjs';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  imports: [NgSelectModule, CommonModule, ReactiveFormsModule],
  standalone: true,
  selector: 'formly-field-typeahead',
  template: `
    <div class="mb-3">
      <label [attr.for]="id" class="form-label">
        {{ props.label }}
        <span *ngIf="props.required" aria-hidden="true">*</span>
      </label>
      <ng-select
        [items]="options$ | async"
        [placeholder]="props.placeholder ?? ''"
        [typeahead]="search$"
        [formControl]="$any(formControl)"
      >
      </ng-select>
    </div>
  `,
})
export class FormlyFieldTypeahead extends FieldType implements OnDestroy, OnInit {
  onDestroy$ = new Subject<void>();
  search$ = new EventEmitter();
  options$: any;

  ngOnInit() {
    this.options$ = this.search$.pipe(
      takeUntil(this.onDestroy$),
      startWith(''),
      filter((v) => v !== null),
      debounceTime(200),
      distinctUntilChanged(),
      switchMap(this.props['search$']),
    );

    this.options$.subscribe();
  }

  ngOnDestroy() {
    this.onDestroy$.complete();
  }
}
